export const isFormulasPage = () => {
  return window.location.pathname === '/fa/formulas' ||
    window.location.pathname?.includes('/fa-formulas-edit');
}
